export default __webpack_public_path__ + "static/media/crew-06-bit.6fa86f3f.svg";